import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { toast } from "sonner";

interface EditRequestStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  request: {
    _id: string;
    status: string;
  };
  onStatusUpdate: (requestId: string, status: string) => void;
}

const statusOptions = [
  { value: "pending", label: "Pending" },
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
  { value: "rejected", label: "Rejected" },
  { value: "delivered", label: "Delivered" },
  { value: "settled", label: "Settled" },
];

const EditRequestStatusModal: React.FC<EditRequestStatusModalProps> = ({
  isOpen,
  onClose,
  request,
  onStatusUpdate,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(request.status);

  const handleSubmit = () => {
    if (selectedStatus === request.status) {
      toast.error("Please select a different status");
      return;
    }
    onStatusUpdate(request._id, selectedStatus);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Request Status</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium">Status</label>
            <Select value={selectedStatus} onValueChange={setSelectedStatus}>
              <SelectTrigger>
                <SelectValue placeholder="Select status" />
              </SelectTrigger>
              <SelectContent>
                {statusOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="flex justify-end space-x-2">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button onClick={handleSubmit}>Update Status</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditRequestStatusModal;
